import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { usePlay, Panel, Stat } from "./usePlay";
import { BetControl } from "@/components/game/BetControl";
import { fmtAZN } from "@/lib/api";
import { sfx } from "@/lib/sound";

const SEG = [0, 1.2, 0, 1.5, 0, 1.2, 0, 2, 0, 1.2, 0, 1.5, 0, 3, 0, 1.2, 0, 1.5, 0, 1.2, 0, 2, 0, 1.2, 0, 1.5, 0, 7, 0, 1.2];
const COLOR = { 0: "#27272a", 1.2: "#2563eb", 1.5: "#16a34a", 2: "#9333ea", 3: "#ea580c", 7: "#FFD700" };
const N = SEG.length, A = 360 / N, R = 200;

const arc = (i) => {
  const a0 = ((i * A - 90) * Math.PI) / 180, a1 = (((i + 1) * A - 90) * Math.PI) / 180;
  return `M0,0 L${R * Math.cos(a0)},${R * Math.sin(a0)} A${R},${R} 0 0 1 ${R * Math.cos(a1)},${R * Math.sin(a1)} Z`;
};

export const WheelGame = ({ mode }) => {
  const { busy, play, finish } = usePlay(mode);
  const [bet, setBet] = useState(1);
  const [rot, setRot] = useState(0);
  const [res, setRes] = useState(null);
  const pending = useRef(null);
  const tick = useRef(null);

  const go = async () => {
    setRes(null);
    const d = await play("/games/wheel", { bet });
    if (!d) return;
    pending.current = d;
    setRot((r) => r - (r % 360) + 360 * 6 + (360 - (d.index * A + A / 2)));
    tick.current = setInterval(sfx.reelTick, 80);
  };

  const done = () => {
    const d = pending.current;
    if (!d) return;
    pending.current = null;
    clearInterval(tick.current);
    setRes(d); finish(d);
  };

  return (
    <div className="grid lg:grid-cols-[340px_1fr] gap-6" data-testid="wheel-game">
      <Panel className="order-2 lg:order-1">
        <div><p className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-2">Mərc</p><BetControl value={bet} onChange={setBet} disabled={busy} testid="wheel-bet" /></div>
        <div className="grid grid-cols-3 gap-2">
          {[1.2, 1.5, 2, 3, 7, 0].map((m) => (
            <div key={m} className="rounded-lg py-2 text-center text-sm font-bold" style={{ background: `${COLOR[m]}33`, color: m ? COLOR[m] : "#a1a1aa", border: `1px solid ${COLOR[m]}` }}>x{m}</div>
          ))}
        </div>
        <button disabled={busy} onClick={go} className="btn-gold w-full rounded-full py-4 font-display font-bold" data-testid="wheel-spin-btn">Çarxı fırlat</button>
        {res && <Stat label="Nəticə" value={res.multiplier ? `x${res.multiplier} · +${fmtAZN(res.win)}` : "x0"} testid="wheel-result" />}
      </Panel>
      <div className="machine-frame rounded-3xl p-6 order-1 lg:order-2 flex items-center justify-center min-h-[380px]">
        <div className="relative w-full max-w-[460px] aspect-square">
          <div className="absolute left-1/2 -top-1 -translate-x-1/2 z-10 w-0 h-0 border-l-[16px] border-r-[16px] border-t-[30px] border-l-transparent border-r-transparent border-t-[#FFD700] drop-shadow-[0_4px_6px_rgba(0,0,0,0.8)]" />
          <motion.svg viewBox="-215 -215 430 430" className="w-full h-full" animate={{ rotate: rot }} transition={{ duration: 4.5, ease: [0.15, 0.7, 0.2, 1] }} onAnimationComplete={done} data-testid="wheel-svg">
            <circle r="212" fill="#b8921f" />
            {SEG.map((m, i) => (
              <g key={i}>
                <path d={arc(i)} fill={COLOR[m]} stroke="#0a0a0a" strokeWidth="1.5" />
                <text transform={`rotate(${i * A + A / 2}) translate(0,-160) rotate(90)`} fill={m === 7 ? "#000" : "#fff"} fontSize="15" fontWeight="800" textAnchor="middle" dominantBaseline="middle" style={{ fontFamily: "Unbounded" }}>{m ? `${m}x` : "0"}</text>
              </g>
            ))}
            {SEG.map((_, i) => <circle key={`b${i}`} cx={206 * Math.cos(((i * A - 90) * Math.PI) / 180)} cy={206 * Math.sin(((i * A - 90) * Math.PI) / 180)} r="3.5" fill="#fff8d0" />)}
            <circle r="46" fill="#111" stroke="#FFD700" strokeWidth="5" />
            <text fill="#FFD700" fontSize="18" fontWeight="900" textAnchor="middle" dominantBaseline="middle" style={{ fontFamily: "Unbounded" }}>JP</text>
          </motion.svg>
        </div>
      </div>
    </div>
  );
};
